import { render, staticRenderFns } from "./LoanOperations.vue?vue&type=template&id=bff41ae4&scoped=true&"
import script from "./LoanOperations.vue?vue&type=script&lang=js&"
export * from "./LoanOperations.vue?vue&type=script&lang=js&"
import style0 from "./LoanOperations.vue?vue&type=style&index=0&id=bff41ae4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff41ae4",
  null
  
)

export default component.exports